import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation, inject } from '@angular/core';

import { markdownTrilogy } from '@bytel/markdown-trilogy';

import { CmsService } from '@services/cms.service';
import { MessageService } from '@services/message.service';

import { DestinationModalComponent } from '@shared/destination-modal/destination-modal.component';

import { InfoWithPepitesItem } from '../../../interfaces/directus-cms.interface';

@Component({
    selector: 'checkout-offer-pepites',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './offer-pepites.component.html',
    styleUrl: './offer-pepites.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class OfferPepitesComponent implements OnInit {
    @Input() public slug: string;
    public infoWithPepitesList: InfoWithPepitesItem;
    protected cmsService: CmsService = inject(CmsService);
    protected messageService: MessageService = inject(MessageService);

    ngOnInit(): void {
        this.cmsService.getPepitesBtbdOffer(this.slug).subscribe((data) => {
            this.infoWithPepitesList = {
                ...data,
                contenu: data?.contenu?.map((el) => ({
                    ...el,
                    pepites: markdownTrilogy(el.pepites),
                })),
            };
        });
    }

    public view(): void {
        this.messageService.openModal(DestinationModalComponent, {
            title: 'Destinations de la zone Europe',
        });
    }
}
